import { isDev } from './env';

export const getIframeUrl = (hostname: string, port = ''): string => {
  const productionUrls = ['www.lucidchart.com', 'lucidspark.com', 'lucid.co', 'lucidforeducation.com'];
  const preProductionUrls = ['www.preprodchart.com', 'preprodspark.lucidmarketingtest.com', 'preprodgo.com'];
  const lucidDevUrl = 'luciddev.app';
  const lucidStagingUrl = 'lucidstaging.app';
  const lucidchartDevUrl = 'dev.lucidchart.ninja';
  const lucidsparkDevUrl = 'devspark.lucidmarketingtest.com';
  const lucidchartStagingUrl = 'lucidchart.ninja';
  const lucidsparkStagingUrl = 'stagingspark.lucidmarketingtest.com';
  const lucidchartOfficeUrl = 'office.lucidchart.com';

  if (productionUrls.includes(hostname)) {
    return 'lucid.app';
  }

  if (preProductionUrls.includes(hostname)) {
    return 'lucidpreprod.app';
  }

  if (hostname.endsWith(lucidchartDevUrl)) {
    return hostname.replace(lucidchartDevUrl, lucidDevUrl);
  }

  if (hostname.endsWith(lucidsparkDevUrl)) {
    return hostname.replace(lucidsparkDevUrl, lucidDevUrl);
  }

  if (hostname.endsWith(lucidchartOfficeUrl)) {
    return hostname.replace(lucidchartOfficeUrl, lucidDevUrl);
  }

  if (hostname.endsWith(lucidsparkStagingUrl)) {
    return hostname.replace(lucidsparkStagingUrl, lucidStagingUrl);
  }

  if (hostname === `localhost${port ? `:${port}` : ''}`) {
    return hostname.replace('localhost', isDev() ? `localhost${port ? `:${port}` : ''}` : '');
  }

  return hostname.replace(lucidchartStagingUrl, lucidStagingUrl);
};

const setupCookieSync = (location: Location | null) => {
  if (!location) return null;
  const { hostname, protocol, port } = location;
  const iframeLocation = getIframeUrl(hostname, port);
  const isLocalhost = iframeLocation === `localhost${port ? `:${port}` : ''}`;
  const syncCookies = document.createElement('iframe');

  syncCookies.style.display = 'none';
  syncCookies.src = `${protocol}//${iframeLocation}/synchronizeCookies?responseDomain=${!isLocalhost ? hostname : iframeLocation}`;
  syncCookies.className = 'cookieSyncIframe';

  document.getElementsByTagName('body')[0].appendChild(syncCookies);

  const syncAllCookies = () => {
    if (window && window.lucid) {
      window.lucid.cookieSyncClient.init(iframeLocation);
      window.lucid.cookieSyncClient.syncAllCookies();
      window.lucid.cookieSyncClient.syncAllMarketingCookies();
    }
  };

  setInterval(() => {
    syncAllCookies();
  }, 1000);
};

export default setupCookieSync;
